import ActionTemplateLayout from "./ActionTemplateLayout";
export default ActionTemplateLayout;
